import React from "react";
import { ListItems } from "../../../../../../../shared/ListItems/ListItems";
import { ColorElement } from "../../../../../../../shared/ColorElement/ColorElement";
import {
  IGeometryOption,
  IOption,
  ISelectItemObjectData,
  IVariant,
  optionObjectOptionT,
} from "../../../../../../../redux/reducers/ui/uiTypes";
import { DropDown } from "../../../../../../../shared/DropDown/DropDown";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../../redux/store";
import { getSelectOptionObjectDataByOptionId } from "../../../../../../../redux/reducers/ui/selectors/objectSelectors";
import { updateValueOptionSelectObjectAction } from "../../../../../../../redux/reducers/ui/actions/actions";
import { ObjectService } from "../../../../../../../services/ObjectService";
import { UrlService } from "../../../../../../../services/UrlService";

interface IProps {
  productId: string;
  type: optionObjectOptionT;
  proxyId: number;
  option: IOption | IGeometryOption;
  title: string;
}
export const ObjectOption: React.FC<IProps> = props => {
  const { productId, type, proxyId, option, title } = props;
  const { id: idOption, variants } = option;
  const dispatch = useAppDispatch();
  const selectIdVariant = useAppSelector(
    getSelectOptionObjectDataByOptionId(productId, type)(proxyId, idOption)
  );

  const activeVariant = variants.find(
    variant => variant.id === selectIdVariant
  );

  const handleChangeVariant = (variant: IVariant) => {
    const dataUpd: Partial<ISelectItemObjectData> = {};

    if (type === "material") {
      dataUpd.materialOptions = {
        [proxyId]: {
          [idOption]: variant.id,
        },
      };
    }

    if (type === "geometry") {
      dataUpd.geometryOptions = {
        [proxyId]: {
          [idOption]: variant.id,
        },
      };
    }
    dispatch(
      updateValueOptionSelectObjectAction({
        productId: productId,
        type: type,
        data: dataUpd,
      })
    );
  };

  return (
    <DropDown title={title}>
      <ListItems
        list={[
          ...ObjectService.getEnabledObjectOptions(variants).map(v => (
            <ColorElement
              img={UrlService.getImageServerCdnUrl(v.image)}
              onClick={() => handleChangeVariant(v)}
              active={activeVariant?.id === v.id}
              name={v.name}
            />
          )),
        ]}
        type={variants[0]?.image ? "image" : "text"}
      />
    </DropDown>
  );
};
